var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{style:(_vm.typographyStyle)},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("title")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }